import { normalizeCartResponse } from '@/features/shop/services/Cart/utils'
import {
  type AllCartsCart,
  type AllShoppingCartsResponse,
} from '@/features/shop/services/Carts/types'

export function formatAllCartsResponse(response: AllShoppingCartsResponse): AllCartsCart[] {
  return (
    (response.data?.carts || [])
      // for compatibility with the old GraphQL response,
      // filter out items that don't have a store_id or have no items
      .filter((cart) => Boolean(cart.context.store_id && cart.cart.num_items))
      .map((cart) => {
        return {
          cart: normalizeCartResponse(cart.cart),
          context: cart.context,
        }
      })
  )
}
